const html = require('choo/html');

module.exports = function(selected, options, translate, changed, htmlId, ariaLabel) {
  let x = selected;

  return html`
    <select
      id="${htmlId}"
      aria-label="${ariaLabel}"
      class="appearance-none cursor-pointer border rounded bg-grey-10 hover:border-blue-50 focus:border-blue-50 pl-1 pr-8 py-1 my-1 h-8 dark:bg-grey-80 dark:border-grey-60"
      onchange="${choose}"
    >
      ${options.map(
        i =>
          html`
            <option value="${i}" ${i === selected ? 'selected' : ''}
              >${translate(i)}</option
            >
          `
      )}
    </select>
  `;

  function choose(event) {
    const target = event.target;
    const value = +target.value;

    if (x !== value) {
      x = value;
      changed(value);
    }
  }
};
